import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import theme from '@/theme';
import styled from '@emotion/styled';
import IconButton from '@mui/material/IconButton';

const StyledIconButtonWrapper = styled(IconButton)<{ isActive?: boolean }>`
    color: ${({ theme }) => theme.colors.secondary.main} !important;
    background-color: #fff !important;
    font-weight: 600;
    border-radius: 8px;
    display: inline-flex;
    font-size: 16px;
    width: 24px;
    height: 24px;

    p {
        margin-left: 8px;
    }

    :focus {
        outline: none;
    }

    :hover {
        background-color: ${({ theme }) => theme.colors.black[200]} !important;
    }

    ${({ isActive }) => isActive && `background-color: ${theme.colors.black[200]} !important;`}
`;

interface Props {
    src: string;
    ariaLabel: string;
    onClick?: () => void;
    isActive?: boolean;
}

export const StyledIconButton = ({ src, ariaLabel, onClick, isActive }: Props) => {
    return (
        <StyledIconButtonWrapper aria-label={ariaLabel} onClick={onClick} isActive={isActive}>
            <MaskedIcon src={src} color={theme.colors.black.main} size="18px" />
        </StyledIconButtonWrapper>
    );
};
